import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FormHeader } from '../styled';
import { Button, InfoCard } from '~ui-kit';
import { config } from '../../configuration';
import { getFormCustomContentByFormType } from '../../utils/common.utils';

const OrderIsDone = props => {
  const lastCompletedTask = useSelector(state => state.form.lastCompletedTask);

  if (!lastCompletedTask) {
    return <Wrapper>Viimeisintä tilausta ei löytynyt.</Wrapper>;
  }

  const customContent =
    lastCompletedTask.customContent ||
    getFormCustomContentByFormType(lastCompletedTask.formType);

  const headerText = `${lastCompletedTask.categoryName}${
    lastCompletedTask.categoryName.split(' ').length > 1 ? ' ' : '' // Add space if task name contains multiple words
  }-tilaus tehty onnistuneesti`;

  return (
    <Wrapper>
      <Header>{headerText}</Header>

      <InfoCard>
        <div>
          Tilauksen numero on {lastCompletedTask.id}.
          <br />
          Voit seurata tilauksen etenemistä{' '}
          <Link to="/tilauslista">tilauslistalta</Link>.
        </div>
      </InfoCard>

      <CustomButtons>
        <LinkButton to={`/palvelut/${customContent}`}>
          <Button
            w="50%"
            minWidth="200px"
            cancel
            onClick={() => {
              if (props.resetForm) props.resetForm();
            }}
          >
            Tee uusi tilaus
          </Button>
        </LinkButton>
        {!window.cordova &&
          lastCompletedTask &&
          lastCompletedTask.printable && (
            <ExternalLinkButton
              href={`${config.apiUrl}orders/pdf/${lastCompletedTask.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button w="50%" minWidth="200px" secondary>
                Tulosta tilaus
              </Button>
            </ExternalLinkButton>
          )}
      </CustomButtons>
    </Wrapper>
  );
};

const Header = styled(FormHeader)`
  margin-bottom: 48px;
`;

const Wrapper = styled.div`
  width: 66%;
`;

const CustomButtons = styled.div`
  display: flex;
  flex-direction: column;
  > * {
    margin: 24px 0;
  }
`;

const LinkButton = styled(Link)`
  width: unset;
`;

const ExternalLinkButton = styled.a`
  width: unset;
`;

export default OrderIsDone;
